import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PointsSummaryFacade } from './facades/points-summary-facade/points-summary.facade';
import { PointsSummaryApiService } from './services/points-summary-api/points-summary-api.service';
import { PointsSummaryEffects } from './store/effects/points-summary.effects';
import { pointsSummaryReducer } from './store/reducers/points-summary.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('pointsSummary', pointsSummaryReducer),
    EffectsModule.forFeature([PointsSummaryEffects]),
  ],
  providers: [PointsSummaryApiService, PointsSummaryFacade],
})
export class PointsSummaryModule {}
